import { StandardEvents } from '@shopify/events';
(() => {
  const bar = document.querySelector('[data-th-sales-bar]');
  if (!bar) return;
  const money = new Intl.NumberFormat(bar.dataset.locale || 'fr-BE', { style: 'currency', currency: bar.dataset.currency || 'EUR' });
  const status = bar.querySelector('[data-th-sales-status]');
  let pending = false;
  const paint = cart => {
    bar.querySelector('[data-th-cart-total]').textContent = money.format(cart.total_price / 100);
    const threshold = cart.total_price < 4000 ? 4000 : 6500;
    bar.querySelector('[data-th-progress]').max = threshold;
    bar.querySelector('[data-th-progress]').value = Math.min(cart.total_price, threshold);
    bar.querySelector('[data-th-progress]').setAttribute('aria-label', cart.total_price < 4000 ? bar.dataset.minimumLabel : bar.dataset.freeLabel);
    bar.querySelector('[data-th-progress-text]').textContent = cart.total_price < 4000 ? bar.dataset.minimum.replace('{amount}', money.format((4000 - cart.total_price) / 100)) : cart.total_price >= 6500 ? bar.dataset.free : bar.dataset.remaining.replace('{amount}', money.format((6500 - cart.total_price) / 100));
    document.querySelectorAll('.th-cart-link span').forEach(el => { el.textContent = '(' + cart.item_count + ')'; el.setAttribute('aria-label', bar.dataset.cartCount.replace('{count}', cart.item_count)); });
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    event.promise?.then(async ({ detail }) => {
      if (detail?.didError) return;
      const response = await fetch(bar.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      paint(await response.json());
      status.textContent = bar.dataset.added;
    }).catch(() => { status.textContent = bar.dataset.error; });
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    try {
      const response = await fetch(bar.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (response.ok) paint(await response.json());
    } catch {}
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.th-quick-add select[name="id"]')) return;
    const selected = event.target.selectedOptions[0];
    const price = event.target.closest('form').querySelector('[data-th-variant-price]');
    if (price && selected?.dataset.price) price.textContent = money.format(Number(selected.dataset.price) / 100);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.th-quick-add')) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    const buttons = document.querySelectorAll('.th-quick-add button');
    buttons.forEach(b => { b.disabled = true; });
    try {
      const mainCart = document.getElementById('thibia-cart');
      if (mainCart) {
        const data = new FormData(mainCart);
        data.delete('checkout');
        data.delete('update');
        const saved = await fetch(bar.dataset.root + 'cart/update.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        if (!saved.ok) throw new Error('cart');
      }
      const added = await fetch(bar.dataset.root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!added.ok) throw new Error('add');
      if (mainCart) { window.location.reload(); return; }
      const response = await fetch(bar.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('read');
      paint(await response.json());
      status.textContent = bar.dataset.added;
    } catch {
      status.textContent = bar.dataset.error;
    } finally {
      pending = false;
      buttons.forEach(b => { b.disabled = false; });
    }
  });
  fetch(bar.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(response => response.ok ? response.json() : null).then(cart => { if (cart) paint(cart); }).catch(() => {});
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-th-filter]');
    if (!button) return;
    const menu = button.closest('#menu');
    menu.querySelectorAll('[data-th-filter]').forEach(b => { const selected = b === button; b.classList.toggle('active', selected); b.setAttribute('aria-pressed', String(selected)); });
    menu.querySelectorAll('[data-th-category]').forEach(card => { card.hidden = button.dataset.thFilter !== 'all' && (button.dataset.thFilter === 'Plat' ? card.dataset.thMeal !== 'true' : card.dataset.thCategory !== button.dataset.thFilter); });
  });
  const nextDeliveryDates = now => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Brussels', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now);
    const values = Object.fromEntries(parts.filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    const today = new Date(Date.UTC(values.year, values.month - 1, values.day));
    let days = (5 - today.getUTCDay() + 7) % 7;
    if (days === 0 && values.hour >= 12) days = 7;
    const friday = new Date(today.getTime() + days * 86400000);
    return { friday, tuesday: new Date(friday.getTime() + 4 * 86400000), wednesday: new Date(friday.getTime() + 5 * 86400000) };
  };
  const showDeliveryDates = () => {
    const dates = nextDeliveryDates(new Date());
    const format = new Intl.DateTimeFormat(bar.dataset.locale || 'fr-BE', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
    document.querySelectorAll('[data-th-delivery-preview]').forEach(panel => {
      panel.querySelector('[data-th-next-dates]').textContent = panel.dataset.dates.replace('{tuesday}', format.format(dates.tuesday)).replace('{wednesday}', format.format(dates.wednesday));
      panel.querySelector('[data-th-cutoff]').textContent = panel.dataset.cutoff.replace('{friday}', format.format(dates.friday));
    });
  };
  showDeliveryDates();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) showDeliveryDates(); });
  const cartForm = document.getElementById('thibia-cart');
  if (cartForm) {
    const labelPostal = () => {
      const zip = cartForm.querySelector('#delivery-location-zip');
      const panel = document.querySelector('[data-th-delivery-preview]');
      if (zip && panel && !zip.getAttribute('aria-label')) {
        zip.setAttribute('aria-label', panel.dataset.postalLabel);
        zip.setAttribute('inputmode', 'numeric');
        zip.setAttribute('autocomplete', 'postal-code');
      }
    };
    labelPostal();
    new MutationObserver(labelPostal).observe(cartForm, { childList: true, subtree: true });
  }
  document.querySelectorAll('[data-th-village]').forEach(select => {
    select.addEventListener('change', () => {
      const panel = select.closest('[data-th-delivery-preview]');
      const output = panel.querySelector('[data-th-zone-status]');
      output.textContent = !select.value ? '' : select.value === 'outside' ? panel.dataset.zoneNo : panel.dataset.zoneYes;
      output.classList.toggle('th-zone-outside', select.value === 'outside');
    });
  });
  document.querySelectorAll('[data-th-meal-builder]').forEach(builder => {
    const floatingMenu = document.querySelector('.th-mobile-menu');
    if (floatingMenu && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => { floatingMenu.hidden = entries.some(entry => entry.isIntersecting); }).observe(builder);
    }
    const form = builder.querySelector('[data-th-builder-form]');
    const inputs = [...builder.querySelectorAll('[data-th-meal-quantity]')];
    const add = builder.querySelector('[data-th-builder-add]');
    const output = builder.querySelector('[data-th-builder-status]');
    let adding = false;
    const selection = () => {
      const target = Number(form.querySelector('[name="meal_target"]:checked').value);
      const items = inputs.filter(input => !input.disabled && input.valueAsNumber > 0).map(input => ({ id: input.dataset.variantId, quantity: input.valueAsNumber, price: Number(input.dataset.price) }));
      return { target, items, count: items.reduce((n, item) => n + item.quantity, 0), total: items.reduce((n, item) => n + item.quantity * item.price, 0) };
    };
    const paintSelection = () => {
      const selected = selection();
      builder.querySelector('[data-th-meal-count]').textContent = selected.count + ' / ' + selected.target;
      builder.querySelector('[data-th-meal-total]').textContent = money.format(selected.total / 100);
      builder.querySelector('[data-th-meal-shipping]').textContent = selected.total >= 6500 ? builder.dataset.shippingFree : builder.dataset.shippingPaid;
      const valid = inputs.every(input => input.disabled || input.checkValidity());
      add.disabled = adding || !valid || selected.count !== selected.target;
      output.textContent = adding ? builder.dataset.busy : selected.count < selected.target ? builder.dataset.need.replace('{count}', selected.target - selected.count) : selected.count > selected.target ? builder.dataset.tooMany.replace('{count}', selected.count - selected.target) : builder.dataset.ready;
    };
    form.addEventListener('input', paintSelection);
    form.addEventListener('change', paintSelection);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const selected = selection();
      if (adding || selected.count !== selected.target || !form.reportValidity()) return;
      adding = true;
      paintSelection();
      try {
        const response = await fetch(bar.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: selected.items.map(item => ({ id: item.id, quantity: item.quantity })) }) });
        if (!response.ok) throw new Error('add');
        window.location.assign(bar.dataset.root + 'cart');
      } catch {
        adding = false;
        paintSelection();
        output.textContent = builder.dataset.error;
      }
    });
    paintSelection();
  });
})();


